import Joi from 'joi';

const stringRequired = Joi.string();

export const productHeaderSchema = Joi.object({
  title: stringRequired,
}).options({ stripUnknown: true });
